module.exports = __webpack_public_path__ + "img/v2_gift_box.fc60554b.svg";